import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from '../../i18n';

export const Sidebar = ({ onNavigate }) => {
  const { isAdmin, isGuest } = useAuth();
  const { t } = useTranslation();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
      isActive ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'
    }`;

  return (
    <nav className="space-y-1">
      {/* ── Скрываем всё, кроме калькулятора, для гостей ── */}
      {!isGuest && (
        <>
          <NavLink to="/dashboard" className={linkClass} onClick={onNavigate}>
            <span>🏠</span> {t('sidebar.dashboard')}
          </NavLink>

          <NavLink to="/workouts" className={linkClass} onClick={onNavigate}>
            <span>🏃</span> {t('sidebar.workouts')}
          </NavLink>

          <NavLink to="/journal" className={linkClass} onClick={onNavigate}>
            <span>📓</span> {t('sidebar.journal')}
          </NavLink>

          {/* ── АНАЛИТИКА И НАГРУЗКА ── */}
          <NavLink to="/analytics" className={linkClass} onClick={onNavigate}>
            <span>📊</span> {t('sidebar.analytics')}
          </NavLink>

          <NavLink to="/preferences" className={linkClass} onClick={onNavigate}>
            <span>⚙️</span> {t('sidebar.preferences')}
          </NavLink>

          <NavLink to="/profile" className={linkClass} onClick={onNavigate}>
            <span>👤</span> {t('sidebar.profile')}
          </NavLink>
        </>
      )}

      {/* ── Калькулятор доступен всем (и гостям, и авторизованным) ── */}
      <NavLink to="/calculator" className={linkClass} onClick={onNavigate}>
        <span>💧</span> {t('sidebar.calculator')}
      </NavLink>

      {/* ── БЛОК АДМИНИСТРАТОРА ── */}
      {!isGuest && isAdmin && (
        <>
          <div className="pt-3 pb-1 px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider">
            {t('sidebar.adminSection') || 'Адміністрування'}
          </div>

          {/* 🛡️ ЖУРНАЛ ЛОГОВ И БЕЗОПАСНОСТИ */}
          <NavLink to="/logs" className={linkClass} onClick={onNavigate}>
            <span>🛡️</span> {t('sidebar.logs') || 'Журнал логів / Безпека'}
          </NavLink>

          <NavLink to="/admin" className={linkClass} onClick={onNavigate}>
            <span>🛠️</span> {t('sidebar.admin')}
          </NavLink>
        </>
      )}
    </nav>
  );
};